export default "__VITE_ASSET__VRmM2Ipz__"